// extracted by mini-css-extract-plugin
export default {"faqStyles":"Faq_faqStyles__0y6Uu","faqList":"Faq_faqList__8dDpK"};